import { j as o } from "./kezios-design-system.esm172.js";
import e from "react";
import { Accordion as t } from "@mantine/core";
import r from "./kezios-design-system.esm144.js";
const d = ({
  children: n,
  openedIcon: c,
  closedIcon: s,
  ...m
}) => /* @__PURE__ */ o.jsx(
  t,
  {
    ...m,
    chevron: /* @__PURE__ */ o.jsxs(o.Fragment, {
      // eslint-disable-next-line css-modules/no-undef-class
      children: [
        e.cloneElement(c, { className: r.opened }),
        // eslint-disable-next-line css-modules/no-undef-class
        e.cloneElement(s, { className: r.closed })
      ]
    }),
    children: n
  }
);
export {
  d as ChangingChevronAccordion
};
